import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Container, Typography } from '@mui/material';
import ClientList from './ClientList';
import ClientProfile from './ClientProfile';

const Clients: React.FC = () => {
    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom>
                Clients
            </Typography>
            <Routes>
                <Route path="/" element={<ClientList />} />
                <Route path="/:id" element={<ClientProfile />} />
            </Routes>
        </Container>
    );
};

export default Clients; 